import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import CommonInputField from 'components/elements/inputs/CommonInputField';
import CommonLinkDeleteButton from 'components/common/link-elements/CommonLinkDeleteButton';
import MenusImageDropZone from '../MenusImageDropZone';
import { changeMenusItem, deleteMenusItem } from 'redux/menu-links/actions';
import { setLastPatchedId } from 'redux/common/actions';
import { connect } from 'react-redux';

import './MenusItem.css';

function MenusItem(props) {
  const { menusItem, changeMenusItem, deleteMenusItem } = props;
  const { t } = useTranslation();

  const priceValidation = value => {
    if (!value) {
      return null;
    } else if (isNaN(Number(value))) {
      return t("Value must be a number");
    } else if ( Number(value) === 0 ) {
      return 'Value must be more than 0';
    } else if (!isNaN(Number(value))) {
      if (!Number.isInteger(Number(value)) && String(value).split('.').pop().length > 2) {
        return t('More than 2 digits after point');
      }
      if (String(value).length > 11) {
        return t('Ensure that there are no more than 10 digits in total');
      }
      if (String(Math.round(String(Math.abs(value)))).length > 8) {
        return t('No more than 8 digits before decimal point');
      }
    }
    return null;
  };

  const inputFieldValidation = value => {
    if (!value) {
      return t('Title should not be empty');
    }
    return null;
  }

  return (
    <div className="menus-item__component">
      <div className="menus-wrapper">
        <div className="inputs-wrapper">
          <div className="menus-item-title">
            <CommonInputField
              key={`menus-item-title-input-key-${menusItem.id}`}
              initialValue={menusItem.description}
              executedFunction={(value) => {
                const form = new FormData();
                form.append('description', value);
                changeMenusItem(menusItem.id, form);
                setLastPatchedId(menusItem.id);
              }}
              maxLength={50}
              placeholder={t("Item text")}
              validationFunction={inputFieldValidation}
            />
          </div>
          <div className="menus-item-price">
            <CommonInputField
              key={`menus-item-price-input-key-${menusItem.id}`}
              initialValue={menusItem.price}
              executedFunction={(value) => {
                const form = new FormData();
                form.append('price', value);
                changeMenusItem(menusItem.id, form);
                setLastPatchedId(menusItem.id);
              }}
              placeholder={t("Item price (optional)")}
              validationFunction={priceValidation}
            />
          </div>
        </div>
        <div className="menus-upload-image">
         <MenusImageDropZone
          item={menusItem}
         />
        </div>
      </div>
      {
        <div className="delete-item">
          <CommonLinkDeleteButton
            key={`menus-delete-item-key-${menusItem.id}`}
            linkItem={menusItem}
            deleteFunction={() => deleteMenusItem(menusItem.id)}
          />
        </div>
      }
    </div>
  );
}

MenusItem.propTypes = {
  menusItem: PropTypes.object.isRequired, 
  changeMenusItem: PropTypes.func.isRequired, 
  deleteMenusItem: PropTypes.func.isRequired,
}

export default connect(null, {
  changeMenusItem,
  setLastPatchedId,
  deleteMenusItem,
})(MenusItem);
